import Tasks from 'APP/Tasks';
import { getGroupsByIds } from 'APP/model/group/groupModel';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';

export const loadNewCallGroup = async (id: string): Promise<Group | null> => {
  try {
    const response = await getGroupsByIds([id]);

    if (response?.items?.[0]) {
      Entities.GroupsStore.merge([response.items[0]]);
      await Tasks.relationships.loadUnknownDataFromGroups({
        groups: [Entities.GroupsStore.getGroupById(id)],
      });
    }

    return Entities.GroupsStore.getGroupById(id);
  } catch (error) {
    return null;
  }
};
